var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayLargeCustomHouse = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#CCA89B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.754 36.532-28.62-26.081c-1.242-1.135-3.132-1.135-4.428 0L9.086 36.532c-1.026.919-1.35 2.323-.864 3.619a3.199 3.199 0 0 0 3.024 2.105h4.59v26.136c0 1.026.864 1.89 1.89 1.89H33.44c1.026 0 1.89-.864 1.89-1.89V52.517h9.234v15.875c0 1.026.864 1.89 1.89 1.89h15.714c1.026 0 1.89-.864 1.89-1.89V42.257h4.59c1.35 0 2.538-.81 3.024-2.106a3.467 3.467 0 0 0-.918-3.619zM63.464 13.367H50.882l14.472 13.175V15.256c0-1.08-.864-1.89-1.89-1.89z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayLargeCustomHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-large-custom-house.f34f015d1e7ea7752a02df683a47fdbf.svg";